import { Home, ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'

interface BreadcrumbItem {
    label: string
    href?: string
}

interface BreadcrumbsProps {
    items: BreadcrumbItem[]
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
    return (
        <nav className="flex items-center space-x-2 text-sm mb-6">
            <Link
                to="/dashboard"
                className="flex items-center text-primary/60 hover:text-primary transition-colors"
            >
                <Home className="w-4 h-4" />
            </Link>

            {items.map((item, index) => (
                <div key={index} className="flex items-center space-x-2">
                    <ChevronRight className="w-4 h-4 text-primary/40" />
                    {item.href ? (
                        <Link
                            to={item.href}
                            className="text-primary/60 hover:text-primary transition-colors font-medium"
                        >
                            {item.label}
                        </Link>
                    ) : (
                        <span className="text-primary font-bold">{item.label}</span>
                    )}
                </div>
            ))}
        </nav>
    )
}
